import { namespace as createVuexClass } from 'vuex-class';
import { Role } from 'ctp-user-auth-service';

export const namespace = 'permissions';
export const store = createVuexClass(namespace);

export const FETCH_CURRENT_USER_ROLE_PERMISSIONS = 'fetchCurrentUserRolePermissions';
export const SET_CURRENT_USER_ROLE_PERMISSIONS = 'setCurrentUserRolePermissions';
export interface IPermissions {
  id: string;
  description: string;
  permissionType: string;
  resourceGroup: string;
  featureGroup: string;
}

export type IRole = Role;

export interface PermissionsState {
  currentUserRole?: IRole;
}
